import React from 'react'
import { FormattedMessage } from 'react-intl'

import messages from 'utils/messages'
import SearchField from 'components/SingleSearch'
import Filter from 'components/Filter'
import { getFilterData } from 'components/Filter/filter'
import { getOutput } from 'components/Filter/clientFilter'
import { DEFAULT_ACCENT } from '../../../utils/constants'

const GridListFilter = ({ defaultFilter, resetFilter, visibleAddButton, filterColumns, onChange, updateGridList, updateFilters, updateSearch, onSearch, searchName, data = [], color = DEFAULT_ACCENT, changePage, onFilterAction, onSearchAction, filterValuesQuery }) => {

  const onFilter = (args) => {
    const { filterData, filteredColumns } = getFilterData(args)
    const result = getOutput(filterData, data)

    const updatedFilters = {
      activeFilterParams: args,
      filterQuery: filterData,
      filteredColumns: filteredColumns,
      filteredData: result
    }

    updateGridList && updateGridList(result)
    updateFilters && updateFilters(updatedFilters)
    onChange && onChange(updatedFilters)
    changePage && changePage(1)
    if (onFilterAction) {
      if (filterData.locations) {
        onFilterAction({
          query: { single: filterData.single, range: filterData.range || [] },
          locations: filterData.locations || []

        })
      } else {
        onFilterAction({
          query: { single: filterData.single, range: filterData.range || [] },

        })
      }
    }
  }

  const onSearchSubmit = (name) => {
    onSearch && onSearch(name)
    updateSearch && updateSearch(name)
    if(onSearchAction) {
      onSearchAction(name)
    }
  }

  return (
    <Filter
      defaultFilter={defaultFilter}
      customClass={color}
      resetFilter={resetFilter}
      onChange={onFilter}
      columns={filterColumns}
      data={data}
      visibleAddButton={visibleAddButton}
      filterValuesQuery={filterValuesQuery}
    >
      <FormattedMessage {...messages.search}>
        {msg => (
          <SearchField
            onSearch={onSearchSubmit}
            customClass={color}
            resetSearch={resetFilter}
            label={msg}
            defaultValue={searchName}
          />
        )}
      </FormattedMessage>
    </Filter>
  )
}

export default GridListFilter